<template>
    <div id="course-list">
        <Head></Head>
        <Search @search="search"></Search>
        <div class="course-list-container">   
            <div class="course-main">
                <ul class="course-container"  v-for="data in getDatas">
                    <li class="course-item" v-for="d in data" :key="d.resourceId">
                        <img :src="d.resourceHeadImage" :alt="d.resourceTitle" @click="openWin(d)">
                        <div class="course-title" @click="openWin(d.url)">{{d.resourceTitle}}</div>
                        <div class="course-info">
                            <span>{{d.visitTimes}}人学过</span>
                            <span class="info-count">共{{d.lessonCount}}课时</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="course-page-index">
                <el-pagination background @current-change="changePage" 
                layout="prev, pager, next, jumper" :page-size="pageSize" :total="datas.totalRecords">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '@/components/Head'
import Search from '@/components/Search'

export default {
    data(){
        return{
            datas:{},
            pageSize:8,
            searchContent:''
        }
    },
    computed:{
        getDatas(){
            var dataList=[];
            var data=[];
            var LessonList=this.datas.data;
            if(LessonList==undefined){
                return dataList;
            }
            for(var i=1;i<=LessonList.length;i++){
                if(i%4==0){
                    data.push(LessonList[i-1]);
                    dataList.push(data);
                    data=[];
                }else{
                    data.push(LessonList[i-1]);
                }
            }
            data.length>0&&dataList.push(data);
            return dataList;
        }
    },
    methods:{
        changePage:function(val){
            /**
             * 查询指定页数据
             */
            var that=this;
            var params="";
            if(this.searchContent==''){
                params =this.$Qs.stringify({
                    pno:val,
                    resourceCategory:'Lesson'
                });
            }else{
                params =this.$Qs.stringify({
                    pno:val,
                    resourceCategory:'Lesson',
                    searchContent:that.searchContent
                });
            }
            
            this.$Axios.post('/Wisdom/video/queryLessonList.htm',params).then((res)=>{
                var data=res.data;
                that.datas=data;
            }).catch(function (error) {
    　　        alert(error);
            });

        },
        openWin:function(data){
            this.$router.push({path:'/lessonDetail',query:{resourceId:data.resourceId}});
        },
        search(data){
            this.searchContent=data.searchContent;
            this.changePage('1');
        }
    },
    mounted(){
        /**
         * 查询首页课程列表
         */
        this.changePage('1');
    },
    components:{
        Head:Head,
        Search:Search
    }
}
</script>
<style scoped>
#course-list{
    width: 100%;
    height: 100%;
}
.course-list-container{
    /*position: absolute;
    left: calc(50% - 590px);
    top: 160px;*/
    width: 1160px;
    height: 100%;
    margin-left: calc(50% - 590px);
}
.course-container{
    /*position:relative;
    left: 0;
    top: 0;*/
    width: 100%;
    height: 274px;
}
.course-item{
    /*position: relative;
    left: 0;
    top: 0;*/
    width: 270px;
    height: 260px;
    float: left;
    list-style: none;
    margin: 7px 10px;
    transition: all 0.8s;
    -moz-transition:all 0.8s;
    -webkit-transition:all 0.8s;
    -o-transition:all 0.8s;
    -ms-transition:all 0.8s;
}
.course-item:hover{
    margin-top: 5px;
    box-shadow: 8px 8px 10px #ccc;
    -moz-box-shadow: 8px 8px 10px #ccc;
    -webkit-box-shadow: 8px 8px 10px #ccc;
    -o-box-shadow: 8px 8px 10px #ccc;
    -ms-box-shadow: 8px 8px 10px #ccc;
}
.course-item img{
    width: 270px;
    height: 200px;
    cursor: pointer;
}
.course-title{
    font-size: 15px;
    text-overflow: ellipsis;
    font-weight: bolder;
    cursor: pointer;
    overflow: hidden;
}
.course-info{
    color:rgba(0, 0, 0, 0.6);
    margin-top: 10px;
}
.info-count{
    margin-left: 20px;
}
.course-page-index{
    /*position: absolute;
    top: 548px;
    left: 0;*/
    width: 100%;
    height: 40px;
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseList.vue